export function isValidUrl(url: string): boolean {
  const validUrlRegex = /^(http|https):\/\/[^ "]+$/;
  return validUrlRegex.test(url);
}
